<script setup lang="ts">
import { ROUTE_NAMES } from '@/router/routeNames';
import { useKundenbereichStore } from '@/stores/kundenbereichStore';
import Nutzungsbedingungen from '@/views/pages/Nutzungsbedingungen.vue';
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const kundenbereichStore = useKundenbereichStore();

const mussNutzungsbedingungenAkzeptieren = computed(() => 
    kundenbereichStore.datenGeladen && 
    !kundenbereichStore.einstellungen?.nutzungsbedingungenGelesen && 
    route.name !== ROUTE_NAMES.KUNDENBEREICH.NUTZUNGSBEDINGUNGEN && 
    route.name !== ROUTE_NAMES.PROBEN.NICHT_FREIGEGEBENE_WARNUNG);
</script>

<template>
    <Nutzungsbedingungen v-if="mussNutzungsbedingungenAkzeptieren" :formularAnzeigen="true" />
    <slot v-else />
</template>
